import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Paper,
  IconButton,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Alert,
  Divider, 
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { ContextSession } from "../../services/ContextSession";

const RegistrarMantenimiento = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Estados
  const [alertaData, setAlertaData] = useState(null);
  const [vehiculoData, setVehiculoData] = useState(null);
  const [isLoadingAlerta, setIsLoadingAlerta] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [talleres, setTalleres] = useState([]);
  const { sessionData } = useContext(ContextSession);
  // Estados para el diálogo de nueva alerta
  const [showNuevaAlertaDialog, setShowNuevaAlertaDialog] = useState(false);
  const [nuevaAlerta, setNuevaAlerta] = useState({
    tipo_mantenimiento: "preventivo",
    descripcion: "",
    kilometraje_programado: "",
    estado: "pendiente",
    vehiculo_id: ""
  });
  const [isLoadingNuevaAlerta, setIsLoadingNuevaAlerta] = useState(false);
  
  // Estados para búsqueda de vehículo por placa
  const [placaBusqueda, setPlacaBusqueda] = useState("");
  const [isLoadingBusqueda, setIsLoadingBusqueda] = useState(false);
  const [placaError, setPlacaError] = useState(false);
  
  // Estado del registro de mantenimiento
  const [registro, setRegistro] = useState({
    tipo_mantenimiento: "",
    descripcion: "",
    kilometraje_programado: "",
    kilometraje: "",
    fecha_realizacion: new Date().toISOString().split("T")[0],
    observaciones: "",
    evidencia: [],
    vehiculo: "",
    alerta: id,
    taller: "",
    usuario_id: "",
    usuario_nombre: ""
  });

   // Obtener usuario_id y nombre de la sesión
   useEffect(() => {
  if (sessionData) {
    const userInfo = getUserInfo();
    
    console.log('Usuario para mantenimiento:', userInfo);

    if (userInfo.id) {
      setRegistro(prev => ({
        ...prev,
        usuario_id: userInfo.id.toString(),
        usuario_nombre: userInfo.name
      }));
    }
  }
}, [sessionData]);
 
   // Función para obtener información del usuario
  const getUserInfo = (userData = sessionData) => {
  if (!userData) return { id: null, name: 'No identificado' };

  // Extraer ID del usuario
  const getId = (data) => 
    data.userId || data.user_id || data.id || data.usuario_id ||
    (data.user && data.user.id) || (data.usuario && data.usuario.id);

  // Extraer nombre del usuario
  const getName = (data) => {
    const name = 
      data.userName || data.username || data.nombre ||
      (data.user && data.user.name) || (data.usuario && data.usuario.nombre);
    
    // Si tenemos nombre y apellido, los combinamos
    if (data.nombre && data.apellido) {
      return `${data.nombre} ${data.apellido}`.trim();
    }
    
    return name || 'Usuario No Identificado';
  };

  return {
    id: getId(userData),
    name: getName(userData)
  };
};

  useEffect(() => {
  const cargarTalleres = async () => {
    try {
      const res = await fetch("https://bei360.injupemp.gob.hn:8444/api/taller/");
      if (!res.ok) throw new Error("Error al cargar talleres");
      const data = await res.json();
      setTalleres(data);
    } catch (err) {
      console.error("Error al obtener talleres:", err);
    }
  };
  cargarTalleres();
}, []);

  // Cargar datos de la alerta específica
  useEffect(() => {
    const cargarAlerta = async () => {
      setIsLoadingAlerta(true);
      setError(null);
      
      try {
        // Cargar datos de la alerta
        const resAlerta = await fetch(`https://bei360.injupemp.gob.hn:8444/api/alertas/${id}/`);
        if (!resAlerta.ok) throw new Error("Alerta no encontrada");
        
        const alertaData = await resAlerta.json();
        setAlertaData(alertaData);
        
        // Prellenar el formulario con los datos de la alerta
        setRegistro(prev => ({
          ...prev,
          tipo_mantenimiento: alertaData.tipo_mantenimiento,
          descripcion: alertaData.descripcion,
          kilometraje_programado: alertaData.kilometraje_programado,
          vehiculo: alertaData.vehiculo
        }));
        
        // Prellenar datos para posible nueva alerta
        setNuevaAlerta(prev => ({
          ...prev,
          tipo_mantenimiento: alertaData.tipo_mantenimiento,
          descripcion: alertaData.descripcion,
          vehiculo_id: alertaData.vehiculo
        }));
        
        // Si la alerta tiene información de placa, buscar el vehículo
        if (alertaData.vehiculo_placa) {
          setPlacaBusqueda(alertaData.vehiculo_placa);
          buscarVehiculoPorPlaca(alertaData.vehiculo_placa);
        }
      } catch (err) {
        console.error("Error al cargar la alerta:", err);
        setError(err.message);
      } finally {
        setIsLoadingAlerta(false);
      }
    };

    if (id) {
      cargarAlerta();
    }
  }, [id]);

  // Función para buscar vehículo por placa
  const buscarVehiculoPorPlaca = async (placa = null) => {
    const placaABuscar = placa || placaBusqueda;
    
    if (!placaABuscar.trim()) {
      setPlacaError(true);
      return;
    }
    
    setIsLoadingBusqueda(true);
    setError(null);
    setPlacaError(false);
    
    try {
      const res = await fetch(`https://bei360.injupemp.gob.hn:8444/api/vehiculos/${placaABuscar.trim()}/`);
      if (!res.ok) throw new Error("Vehículo no encontrado");
      
      const data = await res.json();
      setVehiculoData(data);
      
      // Actualizar el estado de registro con el ID del vehículo
      setRegistro(prev => ({ 
        ...prev, 
        vehiculo: data.id 
      }));

      // Actualizar también para la nueva alerta
      setNuevaAlerta(prev => ({
        ...prev,
        vehiculo_id: data.id
      }));
    } catch (err) {
      setError(err.message);
      setVehiculoData(null);
    } finally {
      setIsLoadingBusqueda(false);
    }
  };

  // Función para obtener nombre del vehículo
  const getNombreVehiculo = () => {
    if (!vehiculoData) return "Vehículo no disponible";
    return `${vehiculoData.marca} ${vehiculoData.modelo} (${vehiculoData.placa})`;
  };

  // Manejador de cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (name === "evidencia") {
      const archivos = Array.from(files);
      setRegistro(prev => ({ ...prev, evidencia: archivos }));
      setAttachments(archivos);
    } else {
      setRegistro(prev => ({ ...prev, [name]: value }));
    }
  };

  // Manejador de cambios para el formulario de nueva alerta
  const handleNuevaAlertaChange = (e) => {
    const { name, value } = e.target;
    setNuevaAlerta(prev => ({ ...prev, [name]: value }));
  };

  // Eliminar archivo adjunto
  const removeAttachment = (index) => {
    const nuevos = [...registro.evidencia];
    nuevos.splice(index, 1);
    setRegistro(prev => ({ ...prev, evidencia: nuevos }));
    setAttachments(nuevos);
  };

  // Crear nueva alerta de mantenimiento
  const crearNuevaAlerta = async () => {
    setIsLoadingNuevaAlerta(true);
    setError(null);

    try {
      const payload = {
        vehiculo: parseInt(nuevaAlerta.vehiculo_id),
        tipo_mantenimiento: nuevaAlerta.tipo_mantenimiento,
        descripcion: nuevaAlerta.descripcion,
        kilometraje_programado: parseFloat(nuevaAlerta.kilometraje_programado),
        estado: nuevaAlerta.estado,
      };

      const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/alertas/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al crear la nueva alerta');
      }

      // Cerrar diálogo y navegar
      setShowNuevaAlertaDialog(false);
      navigate("/Flotas/ProximosMantenimientos");
    } catch (err) {
      console.error("Error al crear nueva alerta:", err);
      setError(err.message);
    } finally {
      setIsLoadingNuevaAlerta(false);
    }
  };

  // Enviar formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar que se haya encontrado el vehículo
    if (!vehiculoData) {
      setError("Debe buscar y seleccionar un vehículo válido");
      return;
    }
    
    setIsLoading(true);
    setError(null);
    
    try {
      // 1. Crear registro en historial
      const res = await fetch("https://bei360.injupemp.gob.hn:8444/api/historial/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          vehiculo: parseInt(registro.vehiculo),
          alerta: registro.alerta,
          tipo_mantenimiento: registro.tipo_mantenimiento,
          descripcion: registro.descripcion,
          kilometraje_programado: registro.kilometraje_programado,
          kilometraje: parseInt(registro.kilometraje),
          fecha_realizacion: registro.fecha_realizacion,
          observaciones: registro.observaciones,
          taller: parseInt(registro.taller),
          usuario_id: parseInt(getUserInfo().id),
          usuario_nombre: getUserInfo().name
        }),
      });
      
      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || "Error al crear el registro de historial");
      }
      
      const historial = await res.json();
      console.log("Historial creado:", historial);
      
      // 2. Subir evidencias
      if (registro.evidencia?.length > 0) {
        for (const archivo of registro.evidencia) {
          const formData = new FormData();
          formData.append("archivo", archivo);
          formData.append("historial", historial.id);
          
          const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/evidencias/', {
            method: 'POST',
            body: formData,
            headers: {
              'Accept': 'application/json',
            }
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Error al subir el archivo");
          }

          const result = await response.json();
          console.log("Evidencia subida:", result);
        }
      }
      
      // 3. Marcar alerta como completada
      try {
        await fetch(`https://bei360.injupemp.gob.hn:8444/api/alertas/${id}/`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estado: "completado" })
        });
      } catch (err) {
        console.warn("No se pudo actualizar el estado de la alerta:", err);
      }
      
      // 4. Mostrar diálogo para programar siguiente mantenimiento
      setShowNuevaAlertaDialog(true);
      
    } catch (err) {
      console.error("Error:", err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoadingAlerta) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error && !alertaData) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="error">{error}</Alert>
        <Button onClick={() => navigate('/Flotas/ProximosMantenimientos')} sx={{ mt: 2 }}>
          Volver
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 2, mb: 2 }}>
      <Paper sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" mb={2}>
          <IconButton onClick={() => navigate('/Flotas/ProximosMantenimientos')} sx={{ mr: 1 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" fontWeight="bold">
            Registrar Mantenimiento
          </Typography>
        </Box>
        
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        {alertaData && (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Datos de la Alerta
              </Typography>
              
              <Divider sx={{ mb: 2 }} />   
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="textSecondary">
                    Vehículo:
                  </Typography>
                  <Typography variant="body1">
                    {vehiculoData ? getNombreVehiculo() : "No seleccionado"}
                  </Typography>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="textSecondary">
                    Tipo de mantenimiento:
                  </Typography>
                  <Typography variant="body1" textTransform="capitalize">
                    {alertaData.tipo_mantenimiento}
                  </Typography>
                </Grid>
                
                <Grid item xs={12}>
                  <Typography variant="body2" color="textSecondary">
                    Descripción:
                  </Typography>
                  <Typography variant="body1">
                    {alertaData.descripcion}
                  </Typography>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="textSecondary">
                    Kilometraje programado:
                  </Typography>
                  <Typography variant="body1">
                    {alertaData.kilometraje_programado} km
                  </Typography>
                </Grid>
                
                {vehiculoData?.kilometraje && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="textSecondary">
                      Kilometraje actual:
                    </Typography>
                    <Typography variant="body1">
                      {vehiculoData.kilometraje} km
                    </Typography>
                  </Grid>
                )}
                
                {vehiculoData?.kilometraje_actual && alertaData.kilometraje_programado && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="textSecondary">
                      Kilometraje faltante:
                    </Typography>
                    <Typography variant="body1" color={
                      (alertaData.kilometraje_programado - vehiculoData.kilometraje_actual) <= 0 ? "error.main" : 
                      (alertaData.kilometraje_programado - vehiculoData.kilometraje_actual) <= 100 ? "warning.main" : "text.primary"
                    }>
                      {Math.abs(alertaData.kilometraje_programado - vehiculoData.kilometraje_actual)} km
                      {(alertaData.kilometraje_programado - vehiculoData.kilometraje_actual) <= 0 ? " (Vencido)" : ""}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        )}
        
        <Typography variant="h6" gutterBottom>
          Datos del Mantenimiento Realizado
        </Typography>
        
        <form onSubmit={handleSubmit}>
          
          
          <TextField
            name="descripcion"
            label="Descripción"
            value={registro.descripcion}
            onChange={handleChange}
            fullWidth
            required
            multiline
            rows={3}
            margin="normal"
          />
          
          <TextField
            name="kilometraje_programado"
            label="Kilometraje programado"
            type="number"
            value={registro.kilometraje_programado}
            onChange={handleChange}
            fullWidth
            required
            margin="normal"
            InputLabelProps={{ shrink: true }}
            disabled
          />
          
          <TextField
            name="kilometraje"
            label="Kilometraje Actual"
            type="number"
            value={registro.kilometraje}
            onChange={handleChange}
            fullWidth
            required
            margin="normal"
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: 0 }}
          />
          
          <TextField
            select
            name="taller"
            label="Seleccione el taller"
            value={registro.taller}
            onChange={handleChange}
            fullWidth
            required
            margin="normal"
            InputLabelProps={{ shrink: true }}
           >
            {talleres.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.nombre} — {t.direccion}
              </MenuItem>
            ))}
          </TextField>


          <TextField
            name="fecha_realizacion"
            label="Fecha de realización"
            type="date"
            value={registro.fecha_realizacion}
            onChange={handleChange}
            fullWidth
            required
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          
          <TextField
            name="observaciones"
            label="Observaciones"
            value={registro.observaciones}
            onChange={handleChange}
            fullWidth
            multiline
            rows={2}
            margin="normal"
          />
          
          {/* Adjuntos */}
          <Box mt={2}>
            <Button
              color="success"
              variant="contained"
              component="label"
              startIcon={<CloudUploadIcon />}
              disabled={isLoading}
            >
              Subir Evidencia
              <input
                type="file"
                name="evidencia"
                accept="image/*,.pdf"
                hidden
                multiple
                onChange={handleChange}
              />
            </Button>
            
            {attachments.length > 0 && (
              <Box mt={1}>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Archivos adjuntos:
                </Typography>
                
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {attachments.map((file, i) => (
                    <li
                      key={i}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 8
                      }}
                    >
                      <span>{file.name}</span>
                      <IconButton
                        color="error"
                        onClick={() => removeAttachment(i)}
                        size="small"
                        disabled={isLoading}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </li>
                  ))}
                </ul>
              </Box>
            )}
          </Box>
          
          <Box display="flex" justifyContent="flex-end" mt={3}>
            <Button
              color="error"
              onClick={() => navigate('/Flotas/ProximosMantenimientos')}
              sx={{ mr: 1 }}
              disabled={isLoading}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ backgroundColor: "#19438C", color: "white" }}
              disabled={isLoading || !vehiculoData}
            >
              {isLoading ? <CircularProgress size={20} /> : "Registrar Mantenimiento"}
            </Button>
          </Box>
        </form>
      </Paper>

      {/* Diálogo para programar siguiente mantenimiento */}
      <Dialog open={showNuevaAlertaDialog} onClose={() => setShowNuevaAlertaDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Programar el siguiente mantenimiento
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box mt={2}> 
            <TextField
              name="descripcion"
              label="Descripción"
              value={nuevaAlerta.descripcion}
              onChange={handleNuevaAlertaChange}
              fullWidth
              required
              multiline
              rows={2}
              margin="normal"
            />
            
            <TextField
              name="kilometraje_programado"
              label="Kilometraje programado para el próximo mantenimiento"
              value={nuevaAlerta.kilometraje_programado}
              onChange={handleNuevaAlertaChange}
              fullWidth
              required
              margin="normal"
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: registro.kilometraje || 0 }}
              helperText={`Kilometraje actual: ${registro.kilometraje || 0} km`}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={crearNuevaAlerta} 
            variant="contained" 
            disabled={isLoadingNuevaAlerta}
            sx={{ backgroundColor: "#19438C", color: "white" }}
          >
            {isLoadingNuevaAlerta ? <CircularProgress size={20} /> : "Guardar"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default RegistrarMantenimiento;